import React from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Input,
  Label,
} from "reactstrap";

export const FlagReportModal = (props) => {
  const isUnflagging = props.flagForm.flagged === false;
  return (
    <Modal
      isOpen={props.modalState}
      toggle={props.toggle}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <ModalHeader toggle={props.toggle}> {isUnflagging ? "Unflag Story" : props.title} </ModalHeader>
      <Form onSubmit={props.onSubmit} noValidate>
        <ModalBody>
          {isUnflagging ? (
            <Label>
              Are you sure you want to unflag this story? It will be visible to you again.
            </Label>
          ) : (
            <>
              <Label>
                The story will no longer be visible to you
              </Label>
              <FormGroup check>
                <Label check>
                  <Input
                    type="radio"
                    name="reportType"
                    value={"1"}
                    onChange={props.handleChange}
                    checked={props.flagForm.reportType === "1"}
                  />{" "}
                  Suspicious/Spam
                </Label>
              </FormGroup>
              <FormGroup check>
                <Label check>
                  <Input
                    type="radio"
                    name="reportType"
                    value={"2"}
                    onChange={props.handleChange}
                    checked={props.flagForm.reportType === "2"}
                  />{" "}
                  Harassment/Offensive
                </Label>
              </FormGroup>
              <FormGroup check>
                <Label check>
                  <Input
                    type="radio"
                    name="reportType"
                    value={"3"}
                    onChange={props.handleChange}
                    checked={props.flagForm.reportType === "3"}
                  />{" "}
                  Inaccurate
                </Label>
              </FormGroup>
              <FormGroup check>
                <Label check>
                  <Input
                    type="radio"
                    name="reportType"
                    value={"4"}
                    onChange={props.handleChange}
                    checked={props.flagForm.reportType === "4"}
                  />{" "}
                  Other
                </Label>
              </FormGroup>
              <FormGroup style={{ marginTop: "20px" }}>
                <Label for="exampleText">Explain Your reason</Label>
                <Input
                  type="textarea"
                  name="reason"
                  id="exampleText"
                  onChange={props.handleChange}
                  value={props.flagForm.reason}
                />
              </FormGroup>
              {props.errorMessage ? (
                <div className="text-danger" style={{ marginTop: "8px", textTransform: "none" }}>
                  {props.errorMessage}
                </div>
              ) : null}
            </>
          )}
        </ModalBody>
        <ModalFooter>
          <Button
            className="default-btn-purple"
            style={{ marginRight: "20px" }}
            onClick={props.toggle}
          >
            Cancel
          </Button>
          <Button className="default-btn-purple" type="submit">{isUnflagging ? "Unflag" : "Submit"}</Button>
        </ModalFooter>
      </Form>
    </Modal>
  );
};

export default FlagReportModal;
